import { motion } from "framer-motion";

const stats = [
  { n: "500+", l: "Projects Completed" },
  { n: "8+", l: "Years Experience" },
  { n: "25+", l: "Cities Served" },
  { n: "4 Years", l: "Airport Monitoring" },
  { n: "1M+", l: "Images Captured" },
  { n: "1000+", l: "Drone Flight Hours" },
];

export const Stats = () => {
  return (
    <section className="bg-[#10193f] py-16" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-6 gap-8">
        {stats.map((s, i) => (
          <motion.div
            key={s.l}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.06 }}
            className="text-center lg:text-left"
          >
            <div className="font-heading text-3xl sm:text-4xl font-black text-white">{s.n}</div>
            <div className="mt-2 text-xs font-semibold uppercase tracking-wider text-[#8b8f99]">{s.l}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
